import React, { Component, Fragment } from 'react';

import { inject, observer } from 'mobx-react';
import { UserPhoto } from 'modules/user';
import { PropTypes } from 'prop-types';

@inject((stores) => ({
  pictureThumbUrl: stores.UserStore.pictureThumbUrl,
  name: stores.UserStore.name,
  profileImgUpdate: stores.UserStore.profileImgUpdate
}))
@observer
class UserPhotoLogged extends Component {
  static propTypes = {
    pictureThumbUrl: PropTypes.string,
    name: PropTypes.string,
    profileImgUpdate: PropTypes.bool
  };

  render() {
    const { pictureThumbUrl, name, profileImgUpdate } = this.props;

    return (
      <Fragment>
        <UserPhoto
          className="header__user__photo header__user__photo--toggle"
          photo={pictureThumbUrl}
          name={name}
          shouldRetryLoad={profileImgUpdate}
        />
        <span className="header__user__name">{name}</span>
      </Fragment>
    );
  }
}

export default UserPhotoLogged;
